import React, { useState } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { Button } from 'components/ui'
import styles from './styles.module.css'

const Code: React.FC<{ children: React.ReactNode; language?: string }> = ({ children, language }) => {
  const [copied, setCopied] = useState(false)
  const [error, setError] = useState(false)

  return (
    <div dir="ltr" className={styles.codeCard}>
      <div className={styles.codeHeader}>
        <span>{language || 'Code'}</span>
        <Button
          variant="ghost"
          className={styles.copyButton}
          onClick={() => {
            navigator.clipboard
              .writeText(String(children).replace(/\n$/, ''))
              .then(() => setCopied(true))
              .catch(() => setError(true))
          }}
        >
          {error ? 'Copy unavailable' : copied ? 'Copied' : 'Copy code'}
        </Button>
      </div>
      <pre>
        <code>{children}</code>
      </pre>
    </div>
  )
}

/** ReactMarkdown sanitizes URLs; omit its legacy javascript:void(0) fallback entirely. */
export const ChatMarkdownLink: React.FC<{ href?: string; title?: string }> = ({ href, title, children }) => (
  <a href={href === 'javascript:void(0)' ? undefined : href} title={title} target="_blank" rel="noopener noreferrer">
    {children}
  </a>
)

const components = {
  a: ChatMarkdownLink,
  table: ({ children }: any) => (
    <div tabIndex={0} role="region" aria-label="Table" className={styles.tableRegion}>
      <table>{children}</table>
    </div>
  ),

  pre: ({ children }: any) => <>{children}</>,

  code: ({ inline, className, children }: any) =>
    inline ? <code dir="ltr">{children}</code> : <Code language={className?.replace('language-', '')}>{children}</Code>,
}

type Props = { children: string; components?: React.ComponentProps<typeof ReactMarkdown>['components'] }
export const ChatMarkdown = React.memo(({ children, components: overrides }: Props) => (
  <div className={styles.root}>
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={{ ...components, ...overrides }}>
      {children}
    </ReactMarkdown>
  </div>
))
